import React from 'react';
import { connect } from 'react-redux';
import ExtraContent from './ExtraContent';

// Functional component wrapper for ExtraContent
const Extra = (props) => {
  return <ExtraContent {...props} />;
};

const mapStateToProps = state => ({
  selected: state.newCourse.selected,
  playerPosition: state.newCourse.playerPosition,
});

export default connect(mapStateToProps)(Extra);
